import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { DATE_VS_TIMESTAMPLIST } from '../kolkata-event-map/kolkata-event-map-cnst';
import { DanaDataService } from '../dana-data.service';

@Component({
  selector: 'app-kolkata-event-sidebar',
  templateUrl: './kolkata-event-sidebar.component.html',
  styleUrls: ['./kolkata-event-sidebar.component.scss']
})
export class KolkataEventSidebarComponent implements OnInit {

  selectedDate: any;
  dateList = {'19-10-2024' : '19_10_2024', '20-10-2024' : '20_10_2024', '21-10-2024' : '21_10_2024'}
  sourceList = {
    IMD_RADAR_MODEL_INPUT_NOWCAST: 'RADAR',
    CTT_MODEL_INPUT_NOWCAST: 'CTT',
    EUMETSAT_MODEL_INPUT_NOWCAST: 'EUMETSAT',
    MODEL_INPUT_NOWCAST: 'RAINFALL',
  }
  isInitialLoad: boolean = false;
  queryParams: any;
  selectedSource: any;
  timestampList:any;
  selectedTimestamp:any
  selected: any;
  
  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router,private danaDataSrv: DanaDataService) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
   }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.requestSelectedFilterParams()
        if(!this.isInitialLoad){
          this.selectedSource = this.queryParams['source']
          this.selectedDate = this.queryParams['date']
          this.selectedTimestamp = this.queryParams['timeStamp']
          this.setTimestampList()
        }
      }
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'KOLKATAEVENT';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  onSubmit() {
    let options = { ...this.queryParams }
    options['timeStamp'] = this.selectedTimestamp
    options['source'] = this.selectedSource
    options['date'] = this.selectedDate
    // options['']
    this.router.navigate(['/nowcastweather/kolkataEvent/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }

  onDateSelect() {
    this.selectedTimestamp = null
    this.setTimestampList()
  }

  setTimestampList() {
    let timeStampList = DATE_VS_TIMESTAMPLIST[this.selectedDate]
    this.formatTimeStampList(timeStampList)
  }

  formatTimeStampList(tsList) {
    this.timestampList = {}
    for(let ts in tsList) {
      let time = this.danaDataSrv.getTimeForDate(tsList[ts])
      this.timestampList[time] = tsList[ts]
    }
  }
}
